import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import template from './index.jade';
import css from './index.inline.styl';

type MessageBannerState = {
  visible: boolean;
};

export class ReportMessageBanner extends Component<MessageBannerState> {
  static get attrsSchema() {
    return {
      closeable: `boolean`,
      message: `string`,
      size: `string`,
      title: `string`,
      type: `string`,
      visible: `boolean`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        visible: false,
      },
      helpers: {
        hideBanner: () => {
          this.dispatchEvent(new CustomEvent(`close`));
          this.update({visible: false});
        },
      },
    };
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (attr === `visible`) {
      // visible attr change overrides internal state
      this.update({visible: this.attr(attr)});
    }
  }
}

export const ReportMessageBannerEl = defineAndMakeJsxFactory(`mp-report-message-banner`, ReportMessageBanner);
export const ReportMessageBannerReact = panel2react(`mp-report-message-banner`, ReportMessageBanner);
